<template>
  <div v-if="verifyAuthority">
    <TitleRow title="Serviços" icon="icons/serviceMenu.svg" />
    <v-row class="mt-10">
      <CustomMenu
        v-for="(menu, index) in serviceConfigurations"
        :key="index"
        :icon="menu.icon"
        :title="menu.title"
        :color="menu.color"
        :authority="menu.authority"
        :paddingCustom="menu.paddingCustom"
        @click="redirectRouter(menu.routerName, { isRHProtegido: isRHProtegido})"
      />
    </v-row>
  </div>
</template>

<script>
import UserUtils from '@/shared/utils/user-utils';
import VerifyRoutesMixin from '@/shared/mixins/routeManagement/verifyRoutesMixin';
import TitleRow from '@/components/Home/AllMenus/TitleRow.vue';
import CustomMenu from '@/components/Home/AllMenus/CustomMenu.vue';
import Authorities from '@/shared/enums/authorities';
import i18n from '@/plugins/i18n';

export default ({
  components: { TitleRow, CustomMenu },
  data: () => ({
    hasNoAuthorities: false,
    isRHProtegido: false,
  }),

  mixins: [
    VerifyRoutesMixin,
  ],

  created() {
    this.userUtils = new UserUtils();
    this.emitVerifyAuthority();
  },

  computed: {
    serviceConfigurations() {
      return [
        {
          icon: 'icons/majority.svg',
          title: 'Maioridade',
          color: 'var(--v-primary-accent-base)',
          routerName: 'Majority',
          authority: this.userUtils.hasAuthorityToAccess({ authority: 'sdi_maioridade' }),
        },
        {
          icon: 'icons/biControlePanelMenuIcon.svg',
          title: i18n.t('biControlPanel.title'),
          color: 'var(--v-primary-accent-base)',
          routerName: 'BIControlPanel',
          authority: this.userUtils.hasAuthorityToAccess({ authority: 'bi_control_panel_approval_view' })
            || this.userUtils.hasAuthorityToAccess({ authority: 'bi_control_panel_parameters_view' })
            || this.userUtils.hasAuthorityToAccess({ authority: 'sdi_bi_panel_parameter_visualizar' })
            || this.userUtils.hasAuthorityToAccess({ authority: 'sdi_bi_panel_parameter_editar' }),
        },
        {
          icon: 'icons/operationalRoutines.png',
          title: 'Conferência de Fatura',
          color: 'var(--v-primary-accent-base)',
          routerName: 'OperationalRoutines',
          authority: this.userUtils.hasAuthorityToAccess({ authority: 'sdi_faturas_conferencia' }),
        },
        {
          icon: 'icons/dataLoad.png',
          title: 'Carga de Dados',
          color: 'var(--v-primary-accent-base)',
          paddingCustom: '15px',
          routerName: 'DataLoad',
          authority: this.userUtils.hasAuthorityToAccess({ authority: 'sdi_import_inv_ext_files_data' }),
        },
        {
          icon: 'icons/operationalRoutines.png',
          title: i18n.t('coparticipation.title'),
          color: 'var(--v-primary-accent-base)',
          routerName: 'Coparticipation',
          authority: this.userUtils.hasAuthorityToAccess({
            authority: Authorities.viewCoparticipation,
          }),
        },
        {
          icon: 'icons/syncCache.svg',
          title: i18n.t('integrationMonitoring.title'),
          color: 'var(--v-primary-accent-base)',
          routerName: 'IntegrationMonitoring',
          authority: this.userUtils.hasAuthorityToAccess({
            authority: Authorities.viewIntegrationMonitoring,
          }),
        },
      ];
    },
    verifyAuthority() {
      return this.serviceConfigurations.some((menu) => menu.authority === true);
    },
  },

  methods: {
    emitVerifyAuthority() {
      this.$emit('verifyAuthorityServiceConfigurations', this.verifyAuthority);
    },
  },
});
</script>
